var URL = require("url");

var Util = {
  isURI: function(url) {
    return URL.parse(url).protocol != null;
  }
};

module.exports = Util;



//////////////////
// WEBPACK FOOTER
// ./~/ethpm/lib/util.js
// module id = 1279
// module chunks = 0 1